import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import nodeItem from './nodeItem.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { flowNodeDetail, auditDetail, flowNodeVerify, countriesDATA, planArea, logisticsData, bankData } from './request';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
// import {} from '@/api/requestData';
export default {
  props: ['id'],
  components: {
    nodeItem
  },
  data() {
    return {
      flowNode: {
        id: -1,
        name: '',
        editableArea: [],
        // actionButton: [{name: '', color: 'primary', goBack: '2', node: ''}],
        actionButton: [{
          index: 1,
          name: '',
          color: 'primary',
          goBack: '',
          node: '',
          fileList: [],
          fileEmptyTipMessage: '请上传文件模板'
        }],
        reviewer: [],
        cc: [],
        method: '',
        copywriting: '',
        copywritingIconName: '',
        customerTag: [],
        sharedPrevNode: true,
        sharedNode: [],
        isEdit: true,
        flowScheduleId: undefined,
        isSponsor: false,
        customerId: ''
      },
      list: [],
      activeKey: ['-1'],
      processList: [],
      infoObj: {},
      tableKey: 0,
      previewVisible: false,
      specifyNodeInfo: [],
      countriesData: [],
      provinceFirstLevel: [],
      bankData: [],
      logisticsData: [],
      provinceArea: [],
      provinceData: [],
      addButtonDisabled: true
    };
  },
  created() {
    this.getOptions();
    setTimeout(() => {
      this.getDataFun();
    }, 400);
  },
  methods: {
    getOptions() {
      // 国家
      countriesDATA({}).then(res => {
        this.countriesData = res || [];
      });

      // 省
      planArea({
        level: 1,
        type: 'noAll'
      }).then(res => {
        this.provinceFirstLevel = res || [];
      });

      // 省市
      planArea({
        level: 2,
        type: 'noAll'
      }).then(res => {
        this.provinceData = res || [];
      });

      // 省市区
      planArea({
        level: 3,
        type: 'noAll'
      }).then(res => {
        this.provinceArea = res || [];
      });

      // 开户行
      bankData({
        level: 1
      }).then(res => {
        this.bankData = res || [];
      });

      // 物流
      logisticsData({
        level: 1
      }).then(res => {
        this.logisticsData = res || [];
      });
      // cascadeList({

      // }).then(res => {
      //   this.cascadeList = res || [];
      // });
    },
    async getDataFun() {
      this.infoObj = await auditDetail({
        auditFlowId: this.id
      });
      this.flowNode.customerId = this.infoObj.customerId;
      this.processList = await auditScheduleResource({
        auditFlowTypeId: this.infoObj.flowTypeId
      });
      this.getInfoFun();
    },
    async getInfoFun() {
      this.tableKey = Date.now();
      const res = await flowNodeDetail({
        auditFlowId: this.id,
        customerId: this.infoObj.customerId
      });
      if (res.length == 0) {
        this.flowNode.customerId = this.infoObj.customerId;
        const obj = recursionCopy(this.flowNode);
        obj.auditFlowId = this.id;
        if (this.list.length == 0) {
          obj.sharedNode = [0];
          // 新增节点可点击
          this.addButtonDisabled = false;
        }
        //审核流标识为申请理赔、问卷时，第一节点审核人默认为发起人
        if (this.infoObj.flowMark === 'claims' || this.infoObj.flowMark === 'questionnaire') {
          obj.isSponsor = true;
        }
        obj.flowMark = this.infoObj.flowMark;
        this.list.push(obj);
      } else {
        this.activeKey = [];
        this.list = res.map((item, index) => {
          // this.activeKey.push(String(item.id));
          item.customerId = this.infoObj.customerId;
          item.isEdit = false;
          return item;
        });
        // 新增节点可点击
        this.addButtonDisabled = false;
      }
    },
    addNodeFun() {
      let num = this.list.find(item => item.isEdit);
      if (num) {
        this.$message.destroy();
        return this.$message.error(this.$t('请先保存完数据再新增') + '!');
      }
      const obj = recursionCopy(this.flowNode);
      obj.auditFlowId = this.id;
      obj.flowMark = this.infoObj.flowMark;
      this.list.push(obj);
      this.activeKey.push(String(-1));
    },
    editFun(index) {
      let num = this.list.find(item => item.isEdit);
      if (num) {
        this.$message.destroy();
        return this.$message.error(this.$t('请先保存完数据再编辑其他节点') + '!');
      }
      this.list[index - 1].isEdit = true;
    },
    async nextFun() {
      let num = this.list.find(item => item.isEdit);
      if (num) {
        this.$message.destroy();
        return this.$message.error(this.$t('请先保存完数据再下一步') + '!');
      }
      const res = await flowNodeVerify({
        auditFlowId: this.id
      });
      if (res.status) {
        this.$emit('next');
      } else {
        this.specifyNodeInfo = res.specifyNodeInfo;
        this.previewVisible = true;
      }
    },
    cancelFun(index) {
      if (this.list[index].id == -1) {
        this.list.splice(index, 1);
      } else {
        this.list[index].isEdit = false;
      }
    }
  }
};